/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from 'react-redux';
import { Input, Tooltip,Button } from 'antd';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';

import { SearchOutlined, EditOutlined } from '@ant-design/icons';
import { API_MASTERFAILURECODES } from '../../../../../commons/api';
import { getMasterList, deleteMaster } from '../../../Utils/FormCalls';

const urlList = {
  list: API_MASTERFAILURECODES.LIST,
  delete: API_MASTERFAILURECODES.DELETE
};

const FailureCodeList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);
  const translationCache = props.translationCache || [];

  let config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['FailureCode'],
    firstTitle: 'FailureCode',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/FailureCodeDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataSource = await getMasterList(urlList.list);
      setDataSource(dataSource);
    };
    fetchData();
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const _deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    const dataSource = await getMasterList(urlList.list);
    setDataSource(dataSource);
  };

  const _editRecord = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const columns = [
    {
      title: translation(translationCache, constant.failureClass),
      dataIndex: 'FailureCode',
      key: 'FailureCode',
      ...getColumnSearchProps('FailureCode')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button onClick={() => _editRecord(record)} >
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];
  config = {
    title: translation(translationCache, 'Failure Class'),

    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',

    filterType: 'ByAttributeValue',
    attributeList: ['FailureCode'],

    firstTitle: 'FailureCode',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',

    actions: ['edit'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/FailureCodeDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };
  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(FailureCodeList);